import Udesk from 'Udesk';
import Component from './route';

export default Udesk.react.udeskify(Component);
